(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bol-coloris-liens"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.bol-coloris input[data-bol-url]')) return;
    if (input.dataset.currentChecked === 'true') return;
    window.location.href = input.dataset.bolUrl;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bol-plaque-immat"] && !Shopify.designMode) return;
  try {
    (function () {
    function wire(root) {
      if (!root || root.dataset.bolWired === '1') return;
      var input = root.querySelector('[data-input]');
      if (!input) return;
      root.dataset.bolWired = '1';

      var preview = root.querySelector('[data-preview]');
      var count = root.querySelector('[data-count]');
      var fallback = root.dataset.fallback || '';
      var upper = root.dataset.uppercase !== 'false';

      if (preview) preview.setAttribute('data-fallback', fallback);

      function render() {
        var v = input.value || '';
        if (upper) {
          var pos = input.selectionStart;
          var up = v.toUpperCase();
          if (up !== v) {
            input.value = up;
            try { input.setSelectionRange(pos, pos); } catch (e) {}
            v = up;
          }
        }
        if (preview) {
          preview.textContent = v.trim() ? v : '';
          var n = v.trim().length;
          var scale = n > 8 ? Math.max(0.34, 8 / n) : 1;
          preview.style.setProperty('--bol-pl-scale', scale.toFixed(3));
        }
        if (count) count.textContent = String(v.length);
      }

      input.addEventListener('input', render);
      render();
    }

    function scan(scope) {
      (scope || document).querySelectorAll('.bol-plaque').forEach(wire);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }

    document.addEventListener('shopify:block:select', function (e) { scan(e.target); });
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.classList && n.classList.contains('bol-plaque')) wire(n);
          else scan(n);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
